import React from 'react';

import styles from './SpecialGeo.css';

interface ISpecialGeoProps {
  label: string;
  icon: React.ReactNode;
  remoteness?: string;
  onClick(e: React.SyntheticEvent<HTMLElement>): void;
}

export function SpecialGeo({ icon, label, remoteness, onClick }: ISpecialGeoProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']} onClick={onClick} rel="noreferrer">
        <div className={styles['icon']}>{icon}</div>
        <div className={styles['name']}>{label}</div>
      </div>
      {remoteness && <div className={styles['remoteness']}>{remoteness}</div>}
    </div>
  );
}
